import { SVGProps } from 'react'

const SvgExternalConnexions = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 96 960 960' {...props}>
    <path d='M120 336V216h120q0 50-35 85t-85 35Zm40 318q-16 2-28-9.5T120 616q0-16 11.5-28t28.5-14q126-14 215-103t103-215q2-17 13.5-28.5T520 216q17 0 28.5 12t9.5 28q-14 159-126.5 271.5T160 654Zm0-161q-16 2-28-9t-12-28q0-16 11-28t28-16q60-12 102.5-54.5T316 255q4-17 16-28t28-11q17 0 28 12t9 28q-13 93-78.5 158.5T160 493Zm280 443q-17 0-28.5-12t-9.5-28q14-159 126.5-271.5T800 498q16-2 28 9.5t12 28.5q0 16-11.5 28T800 578q-126 14-215 103T482 896q-2 17-13.5 28.5T440 936Zm280 0q0-50 35-85t85-35v120H720Zm-120 0q-17 0-28-12t-9-28q13-93 78.5-158.5T800 659q16-2 28 9t12 28q0 16-11 28t-28 16q-60 12-102.5 54.5T644 897q-4 17-16 28t-28 11Z' />
  </svg>
)

export default SvgExternalConnexions
